export function getStatusBackground(status, defaultBg) {
    if (!status && !defaultBg) {
        return '';
    }
    if (defaultBg) {
        return has(`background-${defaultBg}`);
    }
    return has(`background-${status}`);
}
export function classify(prefix) {
    return (classname) => (classname !== '' ? `${prefix}-${classname.toLowerCase()}` : '');
}
export const is = classify('is');
export const has = classify('has');
//# sourceMappingURL=classify.js.map